import { Button, Image, View } from "@/components/ui";
import PayLater from "@/assets/images/3d-icons/book-now-pay-now.png";
import Shield from "@/assets/images/3d-icons/shiled.png";
import CreditCard3d from "@/assets/images/3d-icons/credit-card.png";
import Lock3d from "@/assets/images/3d-icons/lock.png";
import Smile3d from "@/assets/images/3d-icons/smile.png";
import { useState } from "react";
import { BottomDrawerModal } from "@/components/shared/bottom-drawer-modal";
import { Divider } from "@/components/shared/divider";
import { Typography } from "@/components/shared/typography";

export function ServicePayLater() {
  const [isPayLaterModalOpen, setIsPayLaterModalOpen] = useState(false);
  const handleOpenPayLaterModal = () => {
    setIsPayLaterModalOpen(true);
  };
  const handleClosePayLaterModal = () => {
    setIsPayLaterModalOpen(false);
  };
  return (
    <>
      <View
        className="mx-auto flex cursor-pointer flex-row gap-1"
        onClick={() => handleOpenPayLaterModal()}
      >
        <Image src={PayLater} alt="Pay Later" width={16} height={16} />
        <Typography variant="caption-md">Book Now, Pay Later</Typography>
      </View>
      <BottomDrawerModal
        open={isPayLaterModalOpen}
        onOpenChange={handleClosePayLaterModal}
      >
        <View className="flex flex-col">
          <View className="flex flex-col items-center justify-center gap-2">
            <Image src={PayLater} alt="Pay Later" width={48} height={48} />
            <View className="flex flex-col gap-1">
              <Typography variant="label-lg" align="center">
                How "Book Now, Pay Later" Works
              </Typography>
              <Typography
                variant="body-sm"
                align="center"
                color="foreground-intermediate"
              >
                We believe you should only pay when you're satisfied. Here’s
                everything you need to know
              </Typography>
            </View>
          </View>
          <View className="py-4">
            <View className="flex flex-col gap-3 rounded-lg border border-brand-primary px-4 py-3">
              <View className="flex flex-row items-start gap-3">
                <Image
                  src={Shield}
                  alt="Pay After Job Done"
                  width={28}
                  height={28}
                />
                <View className="flex flex-1 flex-col gap-1">
                  <Typography variant="label-sm">
                    Pay only after the job is done
                  </Typography>
                  <Typography variant="body-sm" color="foreground-intermediate">
                    No charges upfront. We only collect payment once the job is
                    completed, so you can feel secure when booking.
                  </Typography>
                </View>
              </View>
              <Divider />
              <View className="flex flex-row items-start gap-3">
                <Image
                  src={CreditCard3d}
                  alt="Payment Methods"
                  width={28}
                  height={28}
                />
                <View className="flex flex-1 flex-col gap-1">
                  <Typography variant="label-sm">
                    Multiple payment methods
                  </Typography>
                  <Typography variant="body-sm" color="foreground-intermediate">
                    We accept selected credit cards and PayNow.
                  </Typography>
                </View>
              </View>
              <Divider />
              <View className="flex flex-row items-start gap-3">
                <Image
                  src={Lock3d}
                  alt="Secure & Flexible"
                  width={28}
                  height={28}
                />
                <View className="flex flex-1 flex-col gap-1">
                  <Typography variant="label-sm">Secure & flexible</Typography>
                  <Typography variant="body-sm" color="foreground-intermediate">
                    We'll notify you before any payment is processed, and you'll
                    always have full visibility into the transaction.
                  </Typography>
                </View>
              </View>
              <Divider />
              <View className="flex flex-row items-start gap-3">
                <Image
                  src={Smile3d}
                  alt="Peace of Mind"
                  width={28}
                  height={28}
                />
                <View className="flex flex-1 flex-col gap-1">
                  <Typography variant="label-sm">Peace of mind</Typography>
                  <Typography variant="body-sm" color="foreground-intermediate">
                    Pay after the service is done. No upfront charges, no hidden
                    fees.
                  </Typography>
                </View>
              </View>
            </View>
          </View>
          <View className="mt-4 flex flex-col">
            <Button
              variant="primary"
              size="lg"
              className="w-full"
              color="CTA"
              onClick={() => handleClosePayLaterModal()}
            >
              Ok, got it!
            </Button>
          </View>
        </View>
      </BottomDrawerModal>
    </>
  );
}
